<!--
 * @Author: xing.huang
 * @Date: 2021-10-27 14:29:49
 * @LastEditTime: 2021-11-09 16:18:03
 * @LastEditors: xing.huang
 * @Description: 
 * @FilePath: \iMaster-Web\src\views\alarm\ExceptionList\addException.vue
 * 
-->
<template>
	<el-dialog  title="新增" :lock-scroll="false" :visible.sync="isShowAddDialog" width="700px" center :close-on-click-modal="false" @close="cancelAdd">
		<el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="config_exception_edit_form">
			<el-row :gutter="20" style="margin-bottom:0px">
				<el-col :span="12">
					<span class="title is-my-required">事件名称：</span>
					<el-form-item prop="eventType" class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                        <el-select style="max-width:180px" clearable size="small" v-model="addForm.eventType" maxlength="16" placeholder="请选择">
                            <el-option label="设备异常" :value='1'></el-option>
                            <el-option label="缺料异常" :value='2'></el-option>
                        </el-select>
					</el-form-item>
				</el-col>
                <el-col :span="12" v-if='addForm.eventType!=2'>
					<span class="title is-my-required">设备信息：</span>
					<el-form-item prop="deviceId" class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                        <el-select style="max-width:180px" clearable size="small" v-model="addForm.deviceId" maxlength="16" placeholder="请选择">
                            <el-option label="设备异常" :value='1'></el-option>
                            <el-option label="缺料异常" :value='2'></el-option>
                        </el-select>
					</el-form-item>
				</el-col>
                <el-col :span="12" v-if='addForm.eventType==2'>
					<span class="title is-my-required">工单号：</span>
					<el-form-item prop="orderCode" class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                        <el-select style="max-width:180px" clearable size="small" v-model="addForm.orderCode" maxlength="16" placeholder="请选择">
                            <el-option label="设备异常" :value='1'></el-option>
                            <el-option label="缺料异常" :value='2'></el-option>
                        </el-select>
					</el-form-item>
				</el-col>
			</el-row>

            <el-row :gutter="20" style="margin-bottom:0px" v-if='addForm.eventType!=2'>
				<el-col :span="12">
					<span class="title">故障代码：</span>
					<el-form-item class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                        <el-input size="small"  v-model="addForm.errCode" maxlength="50"  ></el-input>
					</el-form-item>
				</el-col>
                <el-col :span="12">
					<span class="title">是否停机：</span>
					<el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                        <el-radio-group v-model="addForm.isStop">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="2">否</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>  
            </el-row>

            <el-row :gutter="20" style="margin-bottom:0px" v-if='addForm.eventType==2'>
				<el-col :span="12">
					<span class="title">工序名称：</span>
					<el-form-item  class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                        <el-select style="max-width:180px" clearable size="small" v-model="addForm.procedureId" maxlength="16" placeholder="请选择">
                            <el-option label="工序1" :value='1'></el-option>
                            <el-option label="工序2" :value='2'></el-option>
                        </el-select>
					</el-form-item>
				</el-col>
                <el-col :span="12">
					<span class="title is-my-required">物料信息：</span>
					<el-form-item prop="materialId" class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                        <el-select style="max-width:180px" clearable size="small" v-model="addForm.materialId" maxlength="16" placeholder="请选择">
                            <el-option label="物料1" :value='1'></el-option>
                            <el-option label="物料2" :value='2'></el-option>
                        </el-select>
					</el-form-item>
				</el-col>  
            </el-row>

            <el-row :gutter="20" style="margin-bottom:0px" v-if='addForm.eventType==2'>
				<el-col :span="12" >
					<span class="title is-my-required">设备信息：</span>
					<el-form-item prop="deviceId" class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                        <el-select style="max-width:180px" clearable size="small" v-model="addForm.deviceId" maxlength="16" placeholder="请选择">
                            <el-option label="设备异常" :value='1'></el-option>
                            <el-option label="缺料异常" :value='2'></el-option>
                        </el-select>
					</el-form-item>
				</el-col>
                <el-col :span="12">
					<span class="title">缺料数量：</span>
					<el-form-item prop="count" class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                       <el-input size="small"  v-model="addForm.count" maxlength="50"  ></el-input>
					</el-form-item>
				</el-col>  
            </el-row>
            <el-row :gutter="20" style="margin-bottom:0px" >
				<el-col :span="12" >
					<span class="title is-my-required">处理人：</span>
					<el-form-item prop="userId" class="value"  :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                        <el-select style="max-width:180px" clearable size="small" v-model="addForm.userId" maxlength="16" placeholder="请选择">
                            <el-option label="用户1" :value='1'></el-option>
                            <el-option label="用户2" :value='2'></el-option>
                        </el-select>
					</el-form-item>
				</el-col>
            </el-row>
            <el-row :gutter="20" style="margin-bottom:0px" >
				<el-col :span="24" >
					<span class="title">备注：</span>
					<el-form-item  class="value"  :style="{minWidth:'517px'}">
                        <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 4}" size="small"   v-model="addForm.remark" maxlength="50"  ></el-input>
					</el-form-item>
				</el-col>
            </el-row>
		</el-form>
		<div style="text-align: center;margin-top:20px">
			<el-button type="primary" @click="submitAdd">确 定</el-button>
			<el-button  @click="cancelAdd">取 消</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'ExceptionConfigEdit',
	props: {
		isAdd: Boolean,
		type:Number,
		name:String
	},
	data() {
		return {
            isShowAddDialog:false,
			userList:[{name:'用户1',value:1},{name:'用户2',value:2},{name:'用户3',value:3},{name:'用户4',value:4},],
			W:false,
            addForm:{
                eventType:null,
                deviceId:null,
                errCode:'',
                isStop:1,
                procedureId:null,
                materialId:null,
                orderCode:null,
                count:null,
                userId:null,
                remark:''
            },
			rules:{
				eventType: [
					{required: true, message: '请选择事件名称', trigger: 'blur'}
				],
				deviceId:[
					{required: true, message: '请选择设备', trigger: 'blur'}
				],
				orderCode:[
					{required: true, message: '请选择工单', trigger: 'blur'}
				],
				materialId:[
					{required: true, message: '请选择物料', trigger: 'blur'}
				],
				userId:[
					{required: true, message: '请选择处理人', trigger: 'blur'}
				],
				count:[
					{required: true, message: '请输入数量', trigger: 'blur'}
				],
			},
		}
	},
	
	async mounted(){
        let w = document.documentElement.clientWidth || document.body.clientWidth;
		w >= 1900 ? this.W = true : this.W = false
		window.onresize = () => {
			let w = document.documentElement.clientWidth || document.body.clientWidth;
			w >= 1900 ? this.W = true : this.W = false
		}
	},
	
	methods: {
        cancelAdd(){
			this.$parent.isAdd = false
		},
		submitAdd(){
			this.$refs['addForm'].validate((valid) => {
                if (valid) {
					log('submit')
				}
			})
		},
		
	},
	watch: {
		"isAdd": function (newVal, oldVal) {
			this.isShowAddDialog = this.isAdd;
			if(this.isAdd){
			}
		},
	},
}
</script>

<style scoped>
.title{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display:inline-block;
    text-align: right;
    width: 82px;
}
.value{
    display:inline-block
}
.flow-warp{
	display: flex;
}
.flow{
	flex: 1;
	max-width: 160px;
	margin-right: -10px;
	width: 100%;
	height: 28px;
	line-height: 28px;
	text-align: center;
	color:#23272A;
	font-size: 14px;
	background: url('/static/img/flow.png');
	background-size:100% 100%;
	cursor: pointer;
}

.flowActive{
	color:#fff;
	background: url('/static/img/flow-active.png');
	background-size:100% 100%;
}
.config-warp{
	margin-top: 10px;
	width: 100%;
	height: 172px;
	border: 1px solid #e1e3ec;
	border-radius: 4px;
}
.event-config{
	display: flex;
	height: 100%;
}
.config-user-tab{
	width: 32px;
	height: 100%;
	display: flex;
	flex-direction: column;
}
.config-tab-item{
	flex: 1;
	color: #9e9ca0;
	font-size: 14px;
	border-radius: 1px 0px 0px;
	text-align: center;
	cursor: pointer;
	border: 1px solid;
	border-left: none;
	border-bottom: none;
}
.tabActive{
	background: rgb(18, 131, 237,0.05);
	color: #1283ed;
}
.config-user-content{
	flex: 1;
	width: calc(100% - 32px);
}
 .is-my-required:before {
	content: '*';
	color: #F56C6C;
	margin-right: 4px;
}
</style>
<style>
.config_exception_edit_form .el-input-group__append{
	padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/alarm/ExceptionList/addException.vue